export type PatientRouteParams = {
  patientId: string;
};
